// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1TwGI","rootCenter":"LoadMoreObserver_rootCenter__mF2L8","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1kCKL"};